<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
  import SliderTile from '@/components/modules/occasions/OccasionsSliderTile'

  export default {
    name: 'OccasionsSliderModule',
    components: {
      SliderTile,
    },
    props: {
      options: {
        type: Object,
        default: _ => {},
      },
    },
  }
</script>
